import ChipColors from './ChipColors';

export default [
  {
    text: 'Em cadastro',
    value: 'InRegistration',
    ...ChipColors.light,
  },
  {
    text: 'Em análise',
    value: 'InAnalysis',
    ...ChipColors.warning,
  },
  {
    text: 'Terminado',
    value: 'Finished',
    ...ChipColors.success,
  },
];
